import { mapActions, mapGetters } from "vuex";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import Utils from '@/scripts/Utils';
import Rules from "@/utils/Rules";
import diff from "deep-diff"
import cloneDeep from 'lodash/cloneDeep';

import LeadsService from "@/services/server/LeadsService.js";
import ProjectsService from "@/services/server/ProjectsService.js";
import NextStepProject from "@/components/Projects/NextStepProject.vue"
import UtilsProjects from "@/pages/Projects/Utils/Utils.js";
import HistoricService from "@/services/firebase/Historic/HistoricService";
import LeadsServiceFirebase from "@/services/firebase/Leads/LeadsService";

import selectResponsibleType from "../Components/select-responsible-type.vue"
import selectProjectPartner from "../Components/select-project-partner.vue"
import selectProjectHunter from "../Components/select-project-hunter.vue"
import selectProjectSeller from "../Components/select-project-seller.vue"
import selectProjectCloser from "../Components/select-project-closer.vue"

import historicReference from "@/components/Shared/HistoricList.vue";

import InputMoney from "@/components/Forms/Input/input-money.vue";
import InputFiles from "@/components/Forms/Input/input-files.vue";

import LeadsStorage from '@/services/storage/LeadsStorage';
import NotificationsService from "../../../services/server/NotificationsService";
import UsersService from "../../../services/firebase/Users/UsersService";

import AverageNextStep from "@/components/AverageNextStep/AverageNextStep.vue";


export default {
    name: "Prospecção",
    components: {
        InputFiles,
        InputMoney,
        NextStepProject,
        selectResponsibleType,
        selectProjectPartner,
        selectProjectHunter,
        selectProjectSeller,
        selectProjectCloser,
        historicReference,
        AverageNextStep,
    },
    props: {
        openModal: {
            type: Boolean,
            default: false
        },
        idLead: {
            type: String,
            default: null
        },
        idProject: {
            type: String,
            default: null
        },
        closeFunc: {
            type: Function,
            default: () => { }
        },
        newLead: {
            type: [Object],
            default: () => ({}),
        },
        currentStep: {
            type: String,
            default: null,
        }
    },
    data: () => ({
        compressorConfig: {
            maxWidth: 1200,
            maxHeight: 1200,
            mimeType: "image/webp",
        },
        clickedButton: null,
        is_loading: false,
        is_created: false,
        is_new_project: false,
        mode: 'draft',
        is_create_lead: false,
        dialog: false,
        canSaveDraft: true,
        approvalRequestDateFormatted: null,
        approvalStatusDateFormatted: null,
        radioDocument: null,
        radioDocumentOptions: ['CPF', 'CNPJ', 'Matrícula'],
        proposalTypes: [{ text: 'Gestão', value: "management" }, { text: 'Venda', value: "investment" }, { text: 'Performance', value: "model_performance" }],
        project_name: null,
        project_data: null,
        id_project: null,
        is_completed: false,
        isValidForm: false,
        formattedMinimumRate: null,
        formattedAverageUnitValue: null,
        formattedAverageLocalValue: null,
        prospectingStatus: [
            { name: 'Revisão', value: 'revision' },
            { name: 'Aprovado', value: 'approved' },
            { name: 'Reprovado', value: 'reproved' },
        ],
        prospecting: {
            approvalRequested: null,
            approvalRequestDate: null,
            approvalStatusDate: null,
            approvalStatus: null,
            id_franchisee: null,
            name: null,
            document: null,
            phone: null,
            email: null,
            zip_code: null,
            uf: null,
            city: null,
            district: null,
            address: null,
            house_number: null,
            address_complement: null,

            responsible_name: null,
            responsible_document: null,
            responsible_phone: null,
            responsible_email: null,
            // responsible_role: null,

            registration: null,
            minimum_rate: null,
            financial_average_per_unit: null,
            financial_average_per_local: null,
            number_units: null,
            number_towers: null,
            number_floors: null,
            unit_by_floor: null,
            wcs_by_unit: null,
            no_account: false,
            historics: [],
            observations: null,
            canSaveDraft: true,
            location_type: null,
            commercial_subtype: null,
            residential_subtype: null,
            individual_collective: null,
            is_network: false,
            network_units_count: null,
            // Performance exception request
            performance_exception_requested: false,
            performance_exception_status: null,
            performance_exception_observation: null,
            performance_exception_admin_observation: null,
        },
        requiredFieldListByMode: {
            id_franchisee: {
                draft: true,
                save: true,
            },
            name: {
                draft: true,
                save: true,
            },
            document: {
                draft: true,
                save: true,
            },
            phone: {
                draft: false,
                save: true,
            },
            email: {
                draft: false,
                save: true,
            },

            zip_code: {
                draft: false,
                save: true,
            },
            uf: {
                draft: false,
                save: true,
            },
            city: {
                draft: false,
                save: true,
            },
            district: {
                draft: false,
                save: true,
            },
            address: {
                draft: false,
                save: true,
            },
            house_number: {
                draft: false,
                save: true,
            },
            address_complement: {
                draft: false,
                save: true,
            },

            responsible_name: {
                draft: false,
                save: true,
            },
            responsible_document: {
                draft: false,
                save: true,
            },
            responsible_phone: {
                draft: false,
                save: true,
            },
            responsible_email: {
                draft: false,
                save: true,
            },
            // responsible_role: {
            //     draft: false,
            //     save: true,
            // },

            registration: {
                draft: false,
                save: true,
            },
            minimum_rate: {
                draft: false,
                save: true,
            },
            financial_average_per_unit: {
                draft: false,
                save: true,
            },
            number_units: {
                draft: false,
                save: true,
            },
            number_towers: {
                draft: false,
                save: true,
            },
            number_floors: {
                draft: false,
                save: true,
            },
            unit_by_floor: {
                draft: false,
                save: true,
            },
            wcs_by_unit: {
                draft: false,
                save: true,
            },
        },
        initialProspecting: {},
        fullMonths: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
        ],
        state_acronyms: [
            "AC",
            "AL",
            "AP",
            "AM",
            "BA",
            "CE",
            "DF",
            "ES",
            "GO",
            "MA",
            "MT",
            "MS",
            "MG",
            "PA",
            "PB",
            "PR",
            "PE",
            "PI",
            "RJ",
            "RN",
            "RS",
            "RO",
            "RR",
            "SC",
            "SP",
            "SE",
            "TO",
        ],
        startLoading: false,
        showNoAccountDialog: false,
        showAverageNextStep: false,
        nextStepVariable: "prospecção",
        locationTypeOptions: [
            { text: 'Residencial', value: 'residencial' },
            { text: 'Comercial', value: 'comercial' },
            { text: 'Industrial', value: 'industrial' },
            { text: 'Público', value: 'publico' },
            { text: 'Construtora', value: 'construtora' },
            { text: 'Outro', value: 'outro' }
        ],
        commercialSubtypeOptions: [
            { text: 'Hotel', value: 'hotel' },
            { text: 'Resort', value: 'resort' },
            { text: 'Hospital', value: 'hospital' },
            { text: 'Bares e Restaurantes', value: 'bares_restaurantes' },
            { text: 'Universidades e Faculdades', value: 'universidades_faculdades' },
            { text: 'Outro', value: 'outro' }
        ],
        residentialSubtypeOptions: [
            { text: 'Casas', value: 'casas' },
            { text: 'Aptos', value: 'aptos' },
            { text: 'Condomínio', value: 'condominio' }
        ],
        individualCollectiveOptions: [
            { text: 'Individual', value: 'individual' },
            { text: 'Coletivo', value: 'coletivo' }
        ],
    }),

    computed: {
        ...mapGetters([
            "getCurrentUser",
            "getCurrentUserRank"
        ]),
        disableFieldsWhenApprovalNeededOrApproved() {
            return this.is_loading ||
                (this.getCurrentUserRank === 'Franqueado' &&
                    (this.prospecting.approvalStatus !== 'revision' && !this.canSaveDraft));
        },
        is_draft_mode() {
            return this.mode == 'draft'
        },
        is_save_mode() {
            return this.mode == 'save'
        },
        nameClient() {
            return Rules.required()
        },
        ruleRequired() {
            return Rules.required(this.mode == 'save')
        },
        requiredAtLeastOne() {
            return Rules.requiredAtLeastOne(this.mode == 'save')
        },
        rulesCNPJ() {
            return Rules.cnpj();
        },
        ruleString64() {
            return Rules.string(this.mode == 'save', 1, 64)
        },
        ruleCPF() {
            return Rules.cpf(this.mode == 'save')
        },
        ruleCNPJ() {
            return Rules.cnpj(this.mode == 'save')
        },
        ruleEmail() {
            return Rules.email(this.mode == 'save', 64)
        },
        ruleCEP() {
            return Rules.cep(this.mode == 'save')
        },
        ruleIntPositive() {
            return Rules.number(this.mode == 'save')
        },
        ruleRegistration() {
            return this.prospecting.no_account ? [] : Rules.string(this.mode == 'save', 1, 32)
        },
        ruleMinimumRate() {
            return this.prospecting.no_account ? [] : Rules.required(this.mode == 'save')
        },
        potentialSavings() {
            // Se o cliente não possui conta, mostrar mensagem informativa
            if (this.prospecting.no_account) {
                return 'Não calculável';
            }

            if (!this.prospecting.financial_average_per_local || !this.prospecting.minimum_rate) return '';

            const localAverage = this.formatCurrencyToNumber(this.prospecting.financial_average_per_local);
            const minimumRate = this.formatCurrencyToNumber(this.prospecting.minimum_rate);

            if (isNaN(localAverage) || isNaN(minimumRate)) return '';

            const savings = localAverage - minimumRate;

            // Format as currency
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(savings);
        },
        financialAverageColor() {
            // Se o cliente não possui conta, não mostrar cor de indicador
            if (this.prospecting.no_account) return '';

            if (!this.prospecting.financial_average_per_local || !this.prospecting.minimum_rate) return '';

            const localAverage = this.formatCurrencyToNumber(this.prospecting.financial_average_per_local);
            const minimumRate = this.formatCurrencyToNumber(this.prospecting.minimum_rate);

            if (isNaN(localAverage) || isNaN(minimumRate)) return '';

            // Calcula a porcentagem que a média é maior que a taxa mínima
            const percentage = ((localAverage / minimumRate) - 1) * 100;

            if (percentage < 0) return 'error';
            if (percentage >= 30) return 'success';
            return 'info'; // azul para valores entre 0% e 29%
        },
        phoneMask() {
            const numbers = (this.prospecting.phone || '').replace(/\D/g, '');
            return numbers.length > 10 ? '(##) # ####-####' : '(##) ####-####';
        },
        responsiblePhoneMask() {
            const numbers = (this.prospecting.responsible_phone || '').replace(/\D/g, '');
            return numbers.length > 10 ? '(##) # ####-####' : '(##) ####-####';
        },
        rulePhone() {
            return Rules.phone(this.mode == 'save');
        },
        availableProposalTypes() {
            const baseTypes = [
                { text: 'Gestão', value: "management" }, 
                { text: 'Venda', value: "investment" }, 
            ];

            // Administradores sempre podem selecionar Performance; franqueados seguem bloqueios
            const isFranchisee = this.getCurrentUserRank === 'Franqueado';
            if (!isFranchisee || !this.isPerformanceModelBlocked() || this.prospecting.performance_exception_status === 'approved') {
                baseTypes.splice(2, 0, { text: 'Performance', value: "model_performance" });
            }

            return baseTypes;
        },
        performanceBlockingReasons() {
            return this.getPerformanceBlockingReasons();
        },
        isOldProspectingNeedingApproval() {
            // Detecta prospecções antigas que estão travadas no fluxo
            // São aquelas que têm approvalRequested = true mas não têm approvalStatusDate definido
            return this.prospecting.approvalRequested && 
                   !this.prospecting.approvalStatusDate && 
                   this.getCurrentUserRank !== 'Franqueado';
        },
    },

    methods: {
        ...mapActions([
            "subscribeChannel",
            "publishChannel",
        ]),
        async addStautsProject(id_project, status, statusAdm = null) {
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.PROSPECTING, status, (this.currentStep || UtilsProjects.STEPS.PROSPECTING))
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.PROSPECTING, statusAdm ? statusAdm : status, (this.currentStep || UtilsProjects.STEPS.PROSPECTING), false)
        },
        updateCurrencyField(inputValue) {
            // Remove caracteres não numéricos e converte para número
            const rawValue = parseFloat(
                inputValue.replace(/[^\d,.-]/g, "").replace(",", ".")
            );
            return isNaN(rawValue) ? 0 : rawValue;
        },
        updateButtonMessage() {
            if (this.prospecting.approvalRequestDate && !this.prospecting.approvalStatusDate) {
                return `Análise Solicitada em - ${this.approvalRequestDateFormatted}`;
            }

            switch (this.prospecting.approvalStatus) {
                case 'revision':
                    return `Solicitar Nova Revisão`;
                case 'approved':
                    return `Aprovada em ${this.approvalStatusDateFormatted}`;
                case 'reproved':
                    return `Reprovada em ${this.approvalStatusDateFormatted}`;
                default:
                    // Mostrar "Próximo Passo" para todos os usuários
                    return 'Próximo Passo';
            }
        },
        formatCurrencyValue(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value);
        },
        clearProspecting() {
            this.$nextTick(
                () => {
                    this.prospecting = {
                        id_franchisee: null,
                        name: null,
                        document: null,
                        phone: null,
                        email: null,

                        zip_code: null,
                        uf: null,
                        city: null,
                        district: null,
                        address: null,
                        house_number: null,
                        address_complement: null,

                        responsible_name: null,
                        responsible_document: null,
                        responsible_phone: null,
                        responsible_email: null,
                        // responsible_role: null,

                        registration: null,
                        minimum_rate: null,
                        financial_average_per_unit: null,
                        financial_average_per_local: null,
                        number_units: null,
                        number_towers: null,
                        number_floors: null,
                        unit_by_floor: null,
                        wcs_by_unit: null,
                        no_account: false,
                        historics: [],
                        location_type: null,
                        commercial_subtype: null,
                        residential_subtype: null,
                        individual_collective: null,
                        is_network: false,
                        network_units_count: null,
                        performance_exception_requested: false,
                        performance_exception_status: null,
                        performance_exception_observation: null,
                        performance_exception_admin_observation: null,
                    }
                    // this.is_loading = true;
                    this.is_created = false;
                    this.is_new_project = false;
                    this.is_create_lead = false;
                    this.radioDocument = null;
                    this.project_name = null;
                    this.id_project = null;
                }
            )
        },
        emitProspecting() {
            this.$emit('param:update', this.prospecting)
        },
        async localHistoricSave(historic, index) {
            if (index < 0) {
                this.prospecting.historics.push(historic)
            } else {
                this.$set(this.prospecting.historics, index, historic);
            }
            this.emitProspecting();
        },
        async saveHistoricToFirebase(historic, index) {
            try {
                if (index < 0) {
                    historic.id_project = this.idProject;
                    const [status, result] = await HistoricService.saveHistoric(historic);
                    if (status) {
                        // result agora contém { id, path_file_photo_account, file_photo_account_name }
                        historic.id_doc = result.id;
                        historic.path_file_photo_account = result.path_file_photo_account;
                        historic.file_photo_account_name = result.file_photo_account_name;
                        // Remover campos temporários antes de adicionar à lista
                        delete historic.file_photo_account;
                        delete historic._shouldDeleteFile;
                        this.prospecting.historics.push(historic)
                        showSuccessSnackBar("Histórico salvo com sucesso!")
                    } else {
                        showErrorSnackBar("Histórico com mês/ano já existente!")
                    }
                } else {
                    console.log(historic)
                    const result = await HistoricService.updateHistoric(historic)
    
                    if (result) {
                        this.$set(this.prospecting.historics, index, historic);
                        showSuccessSnackBar("Histórico atualizado com sucesso!")
                    } else {
                        showErrorSnackBar("Ocorreu um erro, tente novamente!")
                    }
                }
                this.emitProspecting();
            } catch (error) {
                console.error('Erro ao salvar o histórico:', error);
            }
        },
        async addHistoric(historic, index) {
            try {
                if (this.idProject) {
                    await this.saveHistoricToFirebase(historic, index)
                } else {
                    await this.localHistoricSave(historic, index)
                }
            } catch (error) {
                console.error('Erro ao salvar o histórico:', error);
            }
        },
        async removeHistoric(index) {
            if (this.idProject) {
                const historic = this.prospecting.historics[index];
                await HistoricService.deleteHistoric(historic)
            }
            this.prospecting.historics = this.prospecting.historics.filter((_, i) => i !== index)
            showSuccessSnackBar("Histórico deletado com sucesso!")
        },
        convertFields(prospecting) {
            let _prospecting = Utils.copyObject(prospecting)
            var fieldsAreIntegers = ['number_floors', 'number_towers', 'number_units', 'unit_by_floor', 'wcs_by_unit']
            var fieldsAreFloats = ['financial_average_per_unit', 'minimum_rate', 'financial_average_per_local']
            for (let key in _prospecting) {
                if (_prospecting[key] === '') {
                    _prospecting[key] = null
                    continue
                }
                _prospecting[key] = fieldsAreIntegers.includes(key) ?
                    parseInt(_prospecting[key])
                    :
                    fieldsAreFloats.includes(key) ? parseFloat(_prospecting[key]) : _prospecting[key]
            }
            return _prospecting
        },
        getProspectingDiff() {
            var prospecting = {}
            var differences = diff(this.initialProspecting, this.prospecting);

            if (!differences) return null
            for (let difference of differences) {
                if (difference.kind !== 'E') continue
                // Detectar somente as mudanças de valores
                let key = difference.path[0]
                let value = difference.rhs
                // É um campo obrigatório mas está vazio
                if (this.requiredFieldListByMode[key][this.mode] && value === '') continue
                prospecting[key] = value === '' ? null : value
            }
            return Object.keys(prospecting).length > 0 ? prospecting : null
        },
        getModifiedProperties(obj1, obj2) {
            const differences = {};

            const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

            for (const key of allKeys) {
                const value1 = obj1[key];
                const value2 = obj2[key];

                if (!(key in obj1)) {
                    differences[key] = value2;
                }

                else if (!(key in obj2)) {
                    continue;
                }

                else if ((value1 instanceof File || value2 instanceof File) ||
                    (value1 instanceof Blob || value2 instanceof Blob)) {
                    const isFile1 = value1 instanceof File || value1 instanceof Blob;
                    const isFile2 = value2 instanceof File || value2 instanceof Blob;

                    if (!isFile1 || !isFile2 ||
                        value1.size !== value2.size ||
                        value1.type !== value2.type ||
                        (value1.name && value2.name && value1.name !== value2.name)) {
                        differences[key] = value2;
                    }
                }

                else if (typeof value1 === 'object' && value1 !== null && value2 !== null && !Array.isArray(value1)) {
                    const nestedDiff = this.getModifiedProperties(value1, value2);
                    if (Object.keys(nestedDiff).length > 0) {
                        differences[key] = nestedDiff;
                    }
                }

                else if (Array.isArray(value1) && Array.isArray(value2)) {
                    const arrayDiff = value2.map((item, index) => {
                        if (!value1[index]) {
                            return item;
                        }

                        if (typeof item === 'object' && item !== null) {
                            return {
                                ...value1[index],
                                ...this.getModifiedProperties(value1[index], item),
                            };
                        }

                        return item;
                    });

                    differences[key] = arrayDiff;
                }

                else if (value1 !== value2) {
                    differences[key] = value2;
                }
            }

            return differences;
        },
        areArraysEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) return false;

            for (let i = 0; i < arr1.length; i++) {
                const value1 = arr1[i];
                const value2 = arr2[i];

                if (typeof value1 === 'object' && typeof value2 === 'object') {
                    if (JSON.stringify(value1) !== JSON.stringify(value2)) return false;
                } else if (value1 !== value2) {
                    return false;
                }
            }
            return true;
        },
        setProspectingWithReact(prospecting) {
            Object.keys(prospecting).forEach(
                (key) => {
                    this.$set(this.prospecting, key, prospecting[key])
                }
            )
        },
        async saveHistoricListWithRetry(historicsList) {
            try {
                const firstAttemptResponse = await HistoricService.saveHistoricList(historicsList);

                const unsavedHistorics = firstAttemptResponse.filter(item => !item.saved);

                if (unsavedHistorics.length === 0) return
                // console.log('Todos os históricos foram salvos com sucesso na primeira tentativa.');

                const historicsToRetry = unsavedHistorics.map(item => item.historic);

                const secondAttemptResponse = await HistoricService.saveHistoricList(historicsToRetry);

                // const stillUnsavedHistorics = secondAttemptResponse.filter(item => !item.saved);

                // if (stillUnsavedHistorics.length === 0) {
                //     console.log('Todos os históricos não salvos foram salvos na segunda tentativa.');
                // } else {
                //     console.log(`Os seguintes históricos ainda não foram salvos após a segunda tentativa:`);
                //     console.log(stillUnsavedHistorics);
                // }
            } catch (error) {
                console.error('Erro ao tentar salvar os históricos:', error);
                throw error;
            }
        },
        async createProject(prospecting) {
            // Criar um projeto
            await this.checkExistImagesFromSave(prospecting)
            const historicsList = cloneDeep(this.prospecting.historics)
            delete this.prospecting.historics
            let [status_lead, response_lead] = await LeadsService.createLead(this.prospecting)
            let [status_project, response_project] = await ProjectsService.createProject({
                id_lead: response_lead.id_lead,
                project_name: this.project_name,
                id_franchisee: this.prospecting.id_franchisee,
                configs: {
                    wpp_notification: true,
                },
            })
            const { id_project } = response_project

            historicsList.forEach(historic => {
                historic.id_project = id_project;
            })

            await this.saveHistoricListWithRetry(historicsList);
            return id_project
        },
        async updateProject(prospecting) {
            this.prospecting.phone = this.formatPhoneNumber(this.prospecting.phone);
            this.prospecting.responsible_phone = this.formatPhoneNumber(this.prospecting.responsible_phone);
            if (!this.canSaveDraft && this.getCurrentUserRank === "Franqueado") {
                showErrorSnackBar("Essa prospecção já foi mandada para aprovação, não é possível editar no momento.");
                return
            } else {
                delete this.prospecting.historics

                this.checkDiffsAndUpdate()
                prospecting = this.getModifiedProperties(this.initialProspecting, this.prospecting)

                await this.checkExistImagesFromSave(prospecting)

                if (Object.keys(prospecting).length) {
                    await LeadsService.updateLead(this.prospecting.id_doc, prospecting)
                }
            }

        },
        async checkDiffsAndUpdate() {
            this.prospecting.phone = this.formatPhoneNumber(this.prospecting.phone);
            this.prospecting.responsible_phone = this.formatPhoneNumber(this.prospecting.responsible_phone);
            const prospecting = this.getModifiedProperties(this.initialProspecting, this.prospecting)

            await this.checkExistImagesFromSave(prospecting)

            if (Object.keys(prospecting).length) {
                await LeadsService.updateLead(this.prospecting.id_doc, prospecting)
            }
        },
        async saveDecision() {
            if (!this.prospecting.approvalStatus) {
                showErrorSnackBar("É necessário selecionar uma decisão!");
                return;
            }
            const { approvalStatus, observations } = this.prospecting;
            if ((['revision', 'reproved'].includes(approvalStatus)) && (!observations || observations.trim() === '')) {
                const message = approvalStatus === 'revision'
                    ? "A revisão precisa conter uma observação!"
                    : "A reprovação precisa conter uma justificativa!";
                showErrorSnackBar(message);
                return;
            }
            this.dialog = true;
            this.mode = 'save'
            this.prospecting.approvalStatusDate = new Date();

            this.prospecting.canSaveDraft = !(this.prospecting.approvalStatus === 'reproved' || this.prospecting.approvalStatus === 'approved');

            let data = {}

            let messageList = []

            this.$nextTick(async () => {
                try {
                    await this.checkDiffsAndUpdate();
                    switch (this.prospecting.approvalStatus) {
                        case 'revision':
                            data = UtilsProjects.buildFranchiseeNotificationData(this.project_data,
                                `Sua prospecção precisa de Atenção! É necessário que você acesse a aba de *PROSPECÇÃO* do projeto para mais informações`);
                            messageList.push(data)
                            await UtilsProjects.updateProjectSteps(this.idProject, 'prospecting', true, true, messageList);
                            await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.PROSPECTING, 'Revisão Solicitada', this.currentStep);
                            await this.addStautsProject(this.idProject, 107, 102)
                            break;
                        case 'approved':
                            await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.PROSPECTING, 'Aprovada', this.currentStep);
                            data = UtilsProjects.buildFranchiseeNotificationData(this.project_data, `Boas Noticías! sua *PROSPECÇÃO* foi aprovada!`)
                            messageList.push(data)
                            await UtilsProjects.updateProjectSteps(this.idProject, 'diagnostic', true, false, messageList);

                            await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, 'Liberado', this.currentStep);
                            await this.addStautsProject(this.idProject, 206)
                            break;
                        case 'reproved':
                            data = UtilsProjects.buildFranchiseeNotificationData(this.project_data,
                                `Lamentamos informar que a sua prospecção não foi aprovada! Acesse seu projeto para mais informações a respeito da reprovação.`)
                            messageList.push(data)

                            await UtilsProjects.updateProjectSteps(this.idProject, 'prospecting', true, true, messageList);
                            await UtilsProjects.createWarningLog(this.idProject, UtilsProjects.STEPS.PROSPECTING, 'Reprovada', this.currentStep);
                            await this.addStautsProject(this.idProject, 101)
                            break;
                    }
                } catch (e) {
                    await UtilsProjects.createWarningLog(this.idProject, UtilsProjects.STEPS.PROSPECTING, `Notificação não enviada`, 'Notificações');
                    console.error(e)
                } finally {
                    showSuccessSnackBar("Decisão salva com sucesso!")
                    this.closeProspectingModal()
                }
            })


        },
        removeLeftZeroAndFormatCurrency() {
            this.prospecting.minimum_rate = parseFloat(this.prospecting.minimum_rate)
        },
        async checkExistImagesFromSave(prospecting) {

            if (prospecting.hasOwnProperty('file_photo_account_dealership')) {
                const allowedTypes = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
                if (this.initialProspecting?.path_file_photo_account_dealership) await LeadsStorage.deleteImg(this.initialProspecting.path_file_photo_account_dealership)
                prospecting.path_file_photo_account_dealership = null
                if (prospecting.file_photo_account_dealership &&
                    allowedTypes.includes(prospecting.file_photo_account_dealership.type)
                ) {
                    prospecting.path_file_photo_account_dealership = await LeadsStorage.uploadFile(this.prospecting.id_doc, prospecting.file_photo_account_dealership)
                } else if (prospecting.file_photo_account_dealership) prospecting.path_file_photo_account_dealership = await LeadsStorage.uploadImg(this.prospecting.id_doc, prospecting.file_photo_account_dealership)

            }
            if (prospecting.hasOwnProperty('file_photo_unit_facade')) {
                await LeadsStorage.deleteImg(this.initialProspecting.path_file_photo_unit_facade)
                prospecting.path_file_photo_unit_facade = null
                if (prospecting.file_photo_unit_facade) prospecting.path_file_photo_unit_facade = await LeadsStorage.uploadImg(this.prospecting.id_doc, prospecting.file_photo_unit_facade)

            }

            delete prospecting.file_photo_unit_facade
            delete prospecting.file_photo_account_dealership
        },
        nextStep() {
            this.mode = 'save'
            this.$nextTick(async () => {
                if (this.$refs.propectingForm && !this.$refs.propectingForm.validate()) {
                    showErrorSnackBar("Há pendência(s) no formulário de prospecção")
                    return
                }

                if (this.prospecting.historics.length < 6 && !this.prospecting.no_account) {
                    showErrorSnackBar("É necessário ter contas dos últimos 6 (seis) meses para análise de viabilidade!");
                    return;
                }
                this.is_loading = true
                this.dialog = true

                // Aprovação automática após validação dos dados obrigatórios
                this.prospecting.canSaveDraft = false;
                this.prospecting.approvalStatus = 'approved';
                this.prospecting.approvalStatusDate = new Date();
                this.prospecting.approvalRequested = true;
                this.prospecting.approvalRequestDate = new Date();

                this.prospecting.phone = this.formatPhoneNumber(this.prospecting.phone);
                this.prospecting.responsible_phone = this.formatPhoneNumber(this.prospecting.responsible_phone);
                let prospecting = this.prospecting
                this.setProspectingWithReact(prospecting)

                if (this.is_new_project) {
                    const id_project = await this.createProject(prospecting)
                    await UtilsProjects.createSuccessLog(id_project, UtilsProjects.STEPS.PROSPECTING, "Aprovada", (this.currentStep || UtilsProjects.STEPS.PROSPECTING))
                    await UtilsProjects.updateProjectSteps(id_project, 'diagnostic', true, false, [])
                    await UtilsProjects.createSuccessLog(id_project, UtilsProjects.STEPS.DIAGNOSTIC, 'Liberado', (this.currentStep || UtilsProjects.STEPS.PROSPECTING));
                    await this.addStautsProject(id_project, 206)
                    this.$router.push(`/projects/${id_project}`)
                } else {
                    await this.updateProject(prospecting)
                    await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.PROSPECTING, "Aprovada", this.currentStep)
                    await UtilsProjects.updateProjectSteps(this.idProject, 'diagnostic', true, false, [])
                    await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, 'Liberado', this.currentStep);
                    await this.addStautsProject(this.idProject, 206)
                }
                showSuccessSnackBar("Prospecção aprovada automaticamente e projeto liberado para Diagnóstico");
                this.closeProspectingModal()

            });
        },
        save_draft() {
            this.mode = 'draft'
            this.$nextTick(async () => {
                if (this.$refs.propectingForm && !this.$refs.propectingForm.validate()) {
                    showErrorSnackBar("Há pendência(s) no formulário de prospecção")
                    return
                }
                this.is_loading = true
                this.dialog = true

                let prospecting = this.prospecting
                this.setProspectingWithReact(prospecting)
                let id_project = this.idProject
                if (this.is_new_project) {
                    id_project = await this.createProject(prospecting)
                    await UtilsProjects.createSuccessLog(id_project, UtilsProjects.STEPS.PROSPECTING, "Criada", (this.currentStep || UtilsProjects.STEPS.PROSPECTING))
                    await UtilsProjects.createInfoLog(id_project, UtilsProjects.STEPS.PROSPECTING, "Rascunho Salvo", this.currentStep)
                    await this.addStautsProject(id_project, 110, 105)
                } else {
                    await this.updateProject(prospecting)
                    if(prospecting.hasOwnProperty('currentStatusADM') || this.getCurrentUserRank === "Franqueado"){
                        await this.addStautsProject(id_project, 110, 105)
                    }
                }
               
                this.closeProspectingModal();
                showSuccessSnackBar("Rascunho salvo com sucesso");
                this.$router.push(`/projects/${id_project}`)
            });
        },
        updateNumberUnits() {
            if (this.countReloads < 3) {
                this.countReloads++;
                return;
            }

            this.prospecting.number_units = ((this.prospecting.number_floors || 0) * (this.prospecting.unit_by_floor || 0) * this.prospecting.number_towers)
        },
        searchCEP(CEP) {
            if (!CEP) return
            if (!CEP.match(/^\d{2}\.\d{3}\-\d{3}$/)) return
            this.is_loading = true
            this.prospecting.uf = null
            this.prospecting.city = null
            this.prospecting.district = null
            this.prospecting.address = null
            this.prospecting.house_number = this.prospecting.house_number ? this.prospecting.house_number : null
            this.prospecting.address_complement = this.prospecting.address_complement ? this.prospecting.address_complement : null
            let url = "https://viacep.com.br/ws/" + CEP.replace(/\D/g, "") + "/json/";
            fetch(url)
                .then((response) => response.json())
                .then((responseJson) => {
                    var { bairro, localidade, logradouro, uf } = responseJson
                    this.prospecting.uf = uf
                    this.prospecting.city = localidade
                    this.prospecting.district = bairro
                    this.prospecting.address = logradouro
                    this.is_loading = false
                })
                .catch((err) => {
                    this.is_loading = false
                    console.error("Erro", err)
                });
            this.is_loading = false
        },
        closeProspectingModal() {
            this.clearProspecting()
            this.closeFunc("prospecting")
            this.$nextTick(
                () => {
                    this.prospecting = {
                        id_franchisee: null,
                        name: null,
                        document: null,
                        phone: null,
                        email: null,

                        zip_code: null,
                        uf: null,
                        city: null,
                        district: null,
                        address: null,
                        house_number: null,
                        address_complement: null,

                        responsible_name: null,
                        responsible_document: null,
                        responsible_phone: null,
                        responsible_email: null,
                        // responsible_role: null,

                        registration: null,
                        minimum_rate: null,
                        financial_average_per_unit: null,
                        financial_average_per_local: null,
                        number_units: null,
                        number_towers: null,
                        number_floors: null,
                        unit_by_floor: null,
                        wcs_by_unit: null,
                        no_account: false,
                        historics: [],
                        location_type: null,
                        commercial_subtype: null,
                        residential_subtype: null,
                        individual_collective: null,
                        is_network: false,
                        network_units_count: null,
                        performance_exception_requested: false,
                        performance_exception_status: null,
                        performance_exception_observation: null,
                        performance_exception_admin_observation: null,
                    }
                    // this.is_loading = true;
                    this.is_created = false;
                    this.is_new_project = false;
                    this.is_create_lead = false;
                    this.radioDocument = null;
                    this.project_name = null;
                    this.id_project = null;
                }
            )
        },
        handleNoAccountChange(value) {
            if (value) {
                this.showNoAccountDialog = true;
            }
        },
        confirmNoAccount() {
            this.showNoAccountDialog = false;
        },
        cancelNoAccount() {
            this.prospecting.no_account = false;
            this.showNoAccountDialog = false;
        },
        formatCurrencyToNumber(value) {
            if (!value) return 0;

            // Remove currency symbols and spaces
            const cleanValue = value.toString()
                .replace(/[^\d,.-]/g, ""); // Remove all non-numeric characters except comma, dot and minus

            // If there's a dot and a comma, the last one is the decimal separator
            const hasDot = cleanValue.includes('.');
            const hasComma = cleanValue.includes(',');

            let number;
            if (hasDot && hasComma) {
                // If both exist, use the last one as decimal separator
                const lastSeparator = cleanValue.lastIndexOf(',') > cleanValue.lastIndexOf('.') ? ',' : '.';
                number = parseFloat(cleanValue
                    .replace(new RegExp(`[${lastSeparator === ',' ? '.' : ','}]`, 'g'), '') // Remove the other separator
                    .replace(lastSeparator, '.')); // Convert the decimal separator to dot
            } else if (hasComma) {
                // If only comma exists, use it as decimal separator
                number = parseFloat(cleanValue.replace(',', '.'));
            } else {
                // If only dot exists or none exist, parse directly
                number = parseFloat(cleanValue);
            }

            return isNaN(number) ? 0 : number;
        },
   
        formatPhoneNumber(phone) {
            if (!phone) return '';
            const numbers = phone.replace(/\D/g, '');
            if (numbers.length === 11) {
                // (99) 99999-9999
                return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
            } else if (numbers.length === 10) {
                // (99) 9999-9999
                return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
            }
            return phone;
        },
        calculateSeasonality() {
            if (!this.prospecting.historics || this.prospecting.historics.length < 2) {
                return { maxAbove: 0, maxBelow: 0 };
            }

            // Ordenar históricos por data (mês/ano)
            const sortedHistorics = [...this.prospecting.historics].sort((a, b) => {
                const dateA = new Date(a.year, a.month - 1);
                const dateB = new Date(b.year, b.month - 1);
                return dateA - dateB;
            });

            // Calcular a média dos valores das contas (usando formatCurrencyToNumber para garantir conversão correta)
            const amounts = sortedHistorics.map(h => {
                const converted = this.formatCurrencyToNumber(h.accountAmount);
                return converted;
            });
            const totalAmount = amounts.reduce((sum, amount) => sum + amount, 0);
            const averageAmount = totalAmount / amounts.length;

            // Se a média for zero, não há como calcular sazonalidade
            if (averageAmount === 0) {
                return { maxAbove: 0, maxBelow: 0 };
            }

            let maxVariationAbove = 0;
            let maxVariationBelow = 0;

            // Calcular variação de cada mês em relação à média
            for (let i = 0; i < sortedHistorics.length; i++) {
                const currentAmount = this.formatCurrencyToNumber(sortedHistorics[i].accountAmount);
                
                if (currentAmount > averageAmount) {
                    // Calcular quanto o mês está acima da média (em percentual)
                    const variation = ((currentAmount - averageAmount) / averageAmount) * 100;
                    maxVariationAbove = Math.max(maxVariationAbove, variation);
                } else if (currentAmount < averageAmount) {
                    // Calcular quanto o mês está abaixo da média (em percentual, valor negativo)
                    const variation = ((currentAmount - averageAmount) / averageAmount) * 100;
                    maxVariationBelow = Math.min(maxVariationBelow, variation);
                }
            }

            return { maxAbove: maxVariationAbove, maxBelow: maxVariationBelow };
        },
        checkAverageReference() {
            if (!this.prospecting.financial_average_per_local) {
                return false;
            }

            const averageValue = this.formatCurrencyToNumber(this.prospecting.financial_average_per_local);
            return averageValue < 8000; // 8 mil
        },
        checkPotentialSavings() {
            // Se o cliente não possui conta, não verificar potencial de economia
            if (this.prospecting.no_account) {
                return false;
            }

            if (!this.prospecting.financial_average_per_local || !this.prospecting.minimum_rate) {
                return false;
            }

            const localAverage = this.formatCurrencyToNumber(this.prospecting.financial_average_per_local);
            const minimumRate = this.formatCurrencyToNumber(this.prospecting.minimum_rate);

            if (isNaN(localAverage) || isNaN(minimumRate) || minimumRate <= 0) {
                return false;
            }

            // Calcula a porcentagem que a média é maior que a taxa mínima
            const percentage = ((localAverage / minimumRate) - 1) * 100;
            return percentage < 30; // Menor que 30%
        },
        isPerformanceModelBlocked() {
            const seasonality = this.calculateSeasonality();
            const averageReference = this.checkAverageReference();
            const noAccount = this.prospecting.no_account;
            const lowPotentialSavings = this.checkPotentialSavings();

            return seasonality.maxAbove > 20 || seasonality.maxBelow < -20 || averageReference || noAccount || lowPotentialSavings;
        },
        getPerformanceBlockingReasons() {
            const reasons = [];
            const seasonality = this.calculateSeasonality();
            const averageReference = this.checkAverageReference();
            const noAccount = this.prospecting.no_account;
            const lowPotentialSavings = this.checkPotentialSavings();

            if (noAccount) {
                reasons.push('Cliente não possui conta na concessionária');
            }

            if (seasonality.maxAbove > 20) {
                reasons.push(`Sazonalidade alta (${seasonality.maxAbove.toFixed(1)}% > 20%)`);
            }

            if (seasonality.maxBelow < -20) {
                reasons.push(`Sazonalidade baixa (${Math.abs(seasonality.maxBelow).toFixed(1)}% < 20% abaixo da média)`);
            }

            if (averageReference) {
                const averageValue = this.formatCurrencyToNumber(this.prospecting.financial_average_per_local);
                reasons.push(`Média de referência baixa (${this.formatCurrencyValue(averageValue)} < R$ 8.000,00)`);
            }

            if (lowPotentialSavings) {
                const localAverage = this.formatCurrencyToNumber(this.prospecting.financial_average_per_local);
                const minimumRate = this.formatCurrencyToNumber(this.prospecting.minimum_rate);
                const percentage = ((localAverage / minimumRate) - 1) * 100;
                reasons.push(`Potencial de economia baixo (${percentage.toFixed(1)}% < 30%)`);
            }

            return reasons;
        },
        removeBlockedPerformanceModel() {
            // Administradores não removem opção Performance automaticamente
            if (this.getCurrentUserRank !== 'Franqueado') return;
            if (this.prospecting.performance_exception_status === 'approved') return;
            if (this.prospecting.desiredProposal && Array.isArray(this.prospecting.desiredProposal)) {
                const hasPerformance = this.prospecting.desiredProposal.includes('model_performance');
                if (hasPerformance && this.isPerformanceModelBlocked()) {
                    // Remover modelo performance da seleção
                    this.prospecting.desiredProposal = this.prospecting.desiredProposal.filter(
                        proposal => proposal !== 'model_performance'
                    );
                    
                    // Mostrar mensagem informativa
                    const reasons = this.getPerformanceBlockingReasons();
                    showErrorSnackBar(`Modelo Performance removido automaticamente: ${reasons.join(', ')}`);
                }
            }
        },
        onLocationTypeChange() {
            // Limpar subtipos quando o tipo de local mudar
            this.prospecting.commercial_subtype = null;
            this.prospecting.residential_subtype = null;
        },
        onNetworkChange() {
            // Limpar quantidade de unidades quando rede for desmarcada
            if (!this.prospecting.is_network) {
                this.prospecting.network_units_count = null;
            }
        },
        async requestPerformanceException() {
            if (this.disableFieldsWhenApprovalNeededOrApproved) return;
            this.prospecting.performance_exception_requested = true;
            this.prospecting.performance_exception_status = 'requested';
            // Persistir imediatamente para evitar perda em navegação
            try {
                await this.checkDiffsAndUpdate();
                showSuccessSnackBar('Revisão solicitada. A liberação do modelo Performance dependerá da aprovação do analista.');
            } catch (e) {
                console.error(e);
                showErrorSnackBar('Não foi possível registrar a solicitação agora. Tente novamente.');
                this.prospecting.performance_exception_requested = false;
                this.prospecting.performance_exception_status = null;
            }
        },
        async savePerformanceExceptionDecision() {
            if (!this.prospecting.performance_exception_status) {
                showErrorSnackBar('É necessário selecionar uma decisão!');
                return;
            }

            this.is_loading = true;
            try {
                // Salvar a decisão
                await this.checkDiffsAndUpdate();
                
                const status = this.prospecting.performance_exception_status;
                const message = status === 'approved' 
                    ? 'Solicitação de revisão do modelo Performance aprovada com sucesso!'
                    : 'Solicitação de revisão do modelo Performance reprovada.';
                
                // Se aprovado, adicionar automaticamente o modelo Performance às propostas desejadas
                if (status === 'approved') {
                    if (!this.prospecting.desiredProposal) {
                        this.prospecting.desiredProposal = [];
                    }
                    if (!this.prospecting.desiredProposal.includes('model_performance')) {
                        this.prospecting.desiredProposal.push('model_performance');
                    }
                }
                
                showSuccessSnackBar(message);
                
                // Se aprovado, o modelo Performance será liberado automaticamente
                // através da lógica existente no computed availableProposalTypes
                
            } catch (e) {
                console.error(e);
                showErrorSnackBar('Não foi possível salvar a decisão. Tente novamente.');
            } finally {
                this.is_loading = false;
            }
        },
        async approveOldProspecting() {
            this.is_loading = true;
            this.dialog = true;
            
            try {
                // Aprovar prospecção antiga que estava travada
                this.prospecting.approvalStatus = 'approved';
                this.prospecting.approvalStatusDate = new Date();
                this.prospecting.canSaveDraft = false;

                this.prospecting.phone = this.formatPhoneNumber(this.prospecting.phone);
                this.prospecting.responsible_phone = this.formatPhoneNumber(this.prospecting.responsible_phone);
                
                let prospecting = this.prospecting;
                this.setProspectingWithReact(prospecting);

                await this.updateProject(prospecting);
                await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.PROSPECTING, "Aprovada Manualmente", this.currentStep);
                await UtilsProjects.updateProjectSteps(this.idProject, 'diagnostic', true, false, []);
                await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.DIAGNOSTIC, 'Liberado', this.currentStep);
                await this.addStautsProject(this.idProject, 206);
                
                showSuccessSnackBar("Prospecção antiga aprovada com sucesso e projeto liberado para Diagnóstico");
                this.closeProspectingModal();
                
            } catch (e) {
                console.error(e);
                showErrorSnackBar('Não foi possível aprovar a prospecção. Tente novamente.');
            } finally {
                this.is_loading = false;
            }
        },
    },

    watch: {
        'prospecting.historics': function () {
            this.prospecting.financial_average_per_local = this.formatCurrencyValue(Math.round(
                (this.prospecting.historics.reduce((sum, historic) => {
                    return sum + (Number(historic.accountAmount) || 0);
                }, 0) / this.prospecting.historics.length) * 100 || 0
            ) / 100);

            this.prospecting.financial_average_per_unit = this.formatCurrencyValue(Math.round(
                (this.prospecting.historics.reduce((sum, historic) => {
                    return sum + (Number(historic.accountAmount) || 0);
                }, 0) / this.prospecting.historics.length / this.prospecting.number_units) * 100 || 0
            ) / 100);

            // Remover modelo performance se estiver bloqueado
            this.removeBlockedPerformanceModel();
        },
        'prospecting.number_units': function () {
            this.prospecting.financial_average_per_unit = this.formatCurrencyValue(Math.round(
                (this.prospecting.historics.reduce((sum, historic) => {
                    return sum + (Number(historic.accountAmount) || 0);
                }, 0) / this.prospecting.historics.length / this.prospecting.number_units) * 100 || 0
            ) / 100);
        },
        'prospecting.financial_average_per_local': function () {
            // Remover modelo performance se a média de referência for baixa
            this.removeBlockedPerformanceModel();
        },
        'prospecting.no_account': function () {
            // Remover modelo performance se o cliente não possui conta
            this.removeBlockedPerformanceModel();
        },
        'prospecting.minimum_rate': function () {
            // Remover modelo performance se o potencial de economia for baixo
            this.removeBlockedPerformanceModel();
        },
        'prospecting.performance_exception_status': function (newStatus) {
            // Se a exceção foi aprovada, adicionar automaticamente o modelo Performance às propostas desejadas
            if (newStatus === 'approved') {
                if (!this.prospecting.desiredProposal) {
                    this.prospecting.desiredProposal = [];
                }
                if (!this.prospecting.desiredProposal.includes('model_performance')) {
                    this.prospecting.desiredProposal.push('model_performance');
                }
            }
        },
    },

    async created() {
        this.is_loading = true;
        this.startLoading = true;
        this.is_create_lead = false

        if (this.idLead) {
            this.is_new_project = false
            const [status, lead] = await LeadsService.getLeadById(this.idLead)
           
            if (!status) {
                showErrorSnackBar("O lead não foi encontrado!")
                this.is_loading = false;
                this.startLoading = false;
                this.closeProspectingModal()
                return
            }

            if (lead?.historics?.length) {
                lead.historics.forEach((historic) => {
                    historic.id_project = this.idProject
                })
                try {
                    await HistoricService.saveHistoricList(lead.historics)

                    await LeadsServiceFirebase.removeHistoricListFromLeads(this.idLead)
                } catch (error) {
                    console.error('Erro ao salvar o histórico:', error);
                }
            }

            lead.historics = await HistoricService.getAllHistoricsByProjectId(this.idProject);

            const [statusProject, project_data] = await ProjectsService.getProjectById(this.idProject)
            this.project_data = project_data;
            if (lead.path_file_photo_account_dealership && lead.hasOwnProperty('path_file_photo_account_dealership')) {
                lead.file_photo_account_dealership = await LeadsStorage.downloadImg(lead.path_file_photo_account_dealership)
            }
            if (lead.path_file_photo_unit_facade && lead.hasOwnProperty('path_file_photo_unit_facade')) {
                lead.file_photo_unit_facade = await LeadsStorage.downloadImg(lead.path_file_photo_unit_facade)
            }

            if (lead.document.match(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/)) this.radioDocument = 'CNPJ'
            else if (lead.document.match(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)) this.radioDocument = 'CPF'
            else this.radioDocument = 'Matrícula'

            lead.phone = this.formatPhoneNumber(lead.phone);
            lead.responsible_phone = this.formatPhoneNumber(lead.responsible_phone);

            this.$nextTick(
                () => {
                    this.initialProspecting = Utils.copyObject(lead)
                    Object.keys(lead).forEach(
                        (key) => {
                            this.$set(this.prospecting, key, lead[key])
                        }
                    )
                    this.approvalStatusDateFormatted = Utils.formatDateDayJs(this.prospecting.approvalStatusDate, "DD/MM/YYYY [às] HH:mm:ss")
                    this.approvalRequestDateFormatted = Utils.formatDateDayJs(this.prospecting.approvalRequestDate, "DD/MM/YYYY [às] HH:mm:ss")
                    this.canSaveDraft = this.prospecting.canSaveDraft;

                    this.is_loading = false;
                }
            )

        } else {
            this.is_new_project = true
            this.isFirstLoad = true;
            this.is_created = true;
            this.is_create_lead = true
            this.is_loading = false;


            this.id_project = null
            this.prospecting.id_franchisee = this.newLead.id_franchisee


            this.radioDocument = this.newLead.type_lead_document_selected
            this.prospecting.document = this.newLead.lead_document
            this.initialProspecting = Utils.copyObject(this.prospecting)
            this.project_name = this.newLead.project_name
        }
        this.startLoading = false;


    },
};